module.exports = __webpack_public_path__ + "img/avatar2.d74ec018.png";